<script lang="ts">
	// The catalogue's main menu, as the Catalogue page draws it: the
	// restaurants, and a way out to Bosla's website for restaurant owners. On a
	// narrow screen it folds behind one button. Drawn by the worker with the
	// page; mounted over that markup only for the button, which is the one part
	// that acts without being a link.

	import Button from '../components/Button.svelte';
	import NavItem from '../components/NavItem.svelte';
	import { nav } from './copy';

	interface Props {
		current: 'home' | 'restaurant';
		ownersHref: string;
	}

	let { current, ownersHref }: Props = $props();

	let open = $state(false);
	// What the toggle controls: the links' own id.
	const navId = 'catalogue-nav';
</script>

<div class="menu" class:open>
	<div class="toggle">
		<Button
			testId="catalogue-menu"
			tone="secondary"
			size="sm"
			label={nav.menu}
			trailingIcon="expand"
			expanded={open}
			controls={navId}
			onPress={() => (open = !open)}
		/>
	</div>
	<nav class="links" id={navId} aria-label={nav.label}>
		<NavItem
			testId="catalogue-nav-home"
			label={nav.restaurants}
			icon="search"
			href="/"
			active={current === 'home'}
		/>
		<NavItem
			testId="catalogue-nav-owners"
			label={nav.owners}
			icon="external"
			href={ownersHref}
			newTab
		/>
	</nav>
</div>

<style>
	.menu {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-end;
		gap: var(--space-2);
	}

	.toggle {
		display: none;
	}

	.links {
		display: flex;
		align-items: center;
		gap: var(--space-2);
	}

	/* A row in the rail fills its column; up here it is as wide as its words. */
	.links :global(.nav) {
		inline-size: auto;
	}

	/* The phone width: under 640px, spelled max-width 639.98px in NavMenu, the
	   catalogue's Shell and the site's SiteHeader, so it covers the widths
	   between 639px and 640px and runs in older browsers. A media query
	   cannot read a token. */
	/* On a phone the button stays on the brand's row: the menu's box steps
	   aside so the button and the links are items of the header's bar, and the
	   open links take a row of their own under it, as the Catalogue page draws
	   them (#614). */
	@media (max-width: 639.98px) {
		.menu {
			display: contents;
		}

		.toggle {
			display: flex;
		}

		.links {
			display: none;
			flex: 1 1 100%;
			flex-direction: column;
			align-items: stretch;
			gap: var(--space-1);
		}

		.links :global(.nav) {
			inline-size: 100%;
		}

		.open .links {
			display: flex;
		}
	}
</style>
